import { render, staticRenderFns } from "./DatosAbonoSGAComponent.vue?vue&type=template&id=c8a7a010"
import script from "./DatosAbonoSGAComponent.vue?vue&type=script&lang=js"
export * from "./DatosAbonoSGAComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports